import { forwardRef } from 'react';
import { Button, type ButtonProps } from '@/Components/ui/button';
import { cn } from '@/lib/utils';
import { Spinner } from './Spinner';

export interface BaseButtonProps extends ButtonProps {
    loading?: boolean;
}

const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
    ({ loading = false, disabled, children, className, ...props }, ref) => {
        // A button that is not loading hands its children through untouched:
        // with `asChild`, Radix's Slot insists on exactly one child, and a
        // `false` spinner slot beside it would trip `React.Children.only`.
        return (
            <Button ref={ref} disabled={disabled || loading} className={cn(className)} {...props}>
                {loading ? (
                    <>
                        <Spinner />
                        {children}
                    </>
                ) : (
                    children
                )}
            </Button>
        );
    },
);
BaseButton.displayName = 'BaseButton';

export { BaseButton };
